import { fetcher } from "helpers/fetcher";

import {
  TCreateCustomerSuccessTicketReq,
  TCustomerSuccessTicketRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const createCustomerSuccessTicket = async (
  payload: TCreateCustomerSuccessTicketReq
) => {
  return await fetcher<
    TCustomerSuccessTicketRes,
    TCreateCustomerSuccessTicketReq["data"]
  >(ENDPOINT.MANAGEMENT.CREATE_CUSTOMER_SUCCESS_TICKET, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.MANAGEMENT.CREATE_CUSTOMER_SUCCESS_TICKET.version,
      [API_HEADER.BU_ID]: payload.idBu,
    },
  });
};

export const mutationCreateCustomerSuccessTicket = async (
  payload: TCreateCustomerSuccessTicketReq
) => {
  return (await createCustomerSuccessTicket(payload)).data.message;
};

mutationCreateCustomerSuccessTicket._key = (
  payload: TCreateCustomerSuccessTicketReq
) => [ENDPOINT.MANAGEMENT.CREATE_CUSTOMER_SUCCESS_TICKET.url, payload];
